<div class="check-box-container">
  <div class="question-header">
    <h6
      class="m-0 p-0"
      [style.font-size]="questionnaire?.mainContentTemplate?.questionStyle?.fontSize + 'px'"
      [style.font-family]="questionnaire?.mainContentTemplate?.questionStyle?.fontFamily"
      [style.font-weight]="questionnaire?.mainContentTemplate?.questionStyle?.boldStyle"
      [style.color]="questionnaire?.mainContentTemplate?.questionStyle?.fontColor"
    >
      {{ questionNumber }}. {{ question?.question || 'Untitled Question' | titlecase }}
      @if (question?.required) {
      <span
        [style.font-size]="'18px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.errorMessageStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor"
        >*</span
      >
      }
    </h6>
  </div>

  <div class="question-content-check-box" [ngClass]="getAlignmentClass(question)">
    @for (option of question?.questionOptions; track option.optionId) {
    <div class="check-box-option">
      <label class="checkbox-label">
        <input
          type="checkbox"
          [value]="option.optionId"
          [checked]="isSelected(option.optionId)"
          [disabled]="disabled"
          (change)="toggleOption(option.optionId)"
        />
        <span class="custom-checkbox"></span>
        <span
          [style.font-size]="questionnaire?.mainContentTemplate?.choiceStyle?.fontSize + 'px'"
          [style.font-family]="questionnaire?.mainContentTemplate?.choiceStyle?.fontFamily"
          [style.font-weight]="questionnaire?.mainContentTemplate?.choiceStyle?.boldStyle"
          [style.color]="questionnaire?.mainContentTemplate?.choiceStyle?.fontColor"
          >{{ option.text | titlecase }}</span
        >
      </label>
    </div>
    @if (isOthersSelected(option.optionId)) {
    <div class="others-input-container">
      <input
        type="text"
        class="others-input"
        [ngModel]="getOthersText(option.optionId)"
        [disabled]="disabled"
        placeholder="Please specify"
        (ngModelChange)="onOthersTextChange(option.optionId, $event)"
        (blur)="onOthersInputBlur()"
      />
    </div>
    } }
  </div>
</div>
